<script>
export default {
  name: "CategoryCreate",
  data() {
    return {
      form: {
        name: "",
        position: 0,
        status: 1,
      },
    };
  },
  computed: {
    nameLength() {
      return this.form.name ? this.form.name.length : 0;
    },
  },
  methods: {
    async onSubmit() {
      // 表单验证
      if (!this.validateForm()) {
        return;
      }

      let loading = null;

      try {
        // 显示加载状态
        loading = this.$loading({
          lock: true,
          text: "保存中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        // 准备提交数据
        const submitData = {
          name: this.form.name.trim(),
          position: this.form.position,
          status: this.form.status,
        };

        // 调用API
        await this.$api.categoryStore(submitData);

        // 关闭加载状态
        loading.close();

        // 显示成功消息
        this.$message({
          type: "success",
          message: "分类创建成功！",
        });

        // 返回分类列表
        this.$router.push("/admin/category");
      } catch (error) {
        // 关闭加载状态
        if (loading) {
          loading.close();
        }

        // 处理错误信息
        let errorMessage = "保存失败，请重试";

        if (error.response && error.response.data) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.response.data.errors) {
            // 处理验证错误
            const errors = error.response.data.errors;
            const firstError = Object.values(errors)[0];
            if (Array.isArray(firstError) && firstError.length > 0) {
              errorMessage = firstError[0];
            }
          }
        }

        // 显示错误消息
        this.$message({
          type: "error",
          message: errorMessage,
        });

        console.error("保存分类失败:", error);
      }
    },

    goBack() {
      // 返回分类列表
      this.$router.push("/admin/category");
    },

    validateForm() {
      // 验证分类名称
      if (!this.form.name || !this.form.name.trim()) {
        this.$message({
          type: "warning",
          message: "请输入分类名称",
        });
        return false;
      }

      if (this.form.name.trim().length > 50) {
        this.$message({
          type: "warning",
          message: "分类名称不能超过50个字符",
        });
        return false;
      }

      // 验证权重
      if (this.form.position < 0) {
        this.$message({
          type: "warning",
          message: "权重不能为负数",
        });
        return false;
      }

      return true;
    },
  },
};
</script>

<template>
  <div class="category-create">
    <div class="form-container">
      <h2 class="page-title">新增分类</h2>
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        class="category-form"
      >
        <el-form-item label="分类名称" required>
          <el-input
            v-model="form.name"
            maxlength="50"
            show-word-limit
            placeholder="请输入分类名称"
            style="width: 400px"
          ></el-input>
        </el-form-item>

        <el-form-item label="权重" required>
          <el-input-number
            v-model="form.position"
            :min="0"
            :max="9999"
            controls-position="right"
            style="width: 200px"
          ></el-input-number>
          <span class="form-tip">数值越大排序越靠前</span>
        </el-form-item>

        <el-form-item label="状态">
          <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          >
          </el-switch>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit" size="medium"
            >立即创建</el-button
          >
          <el-button @click="goBack" size="medium">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<style scoped>
.category-create {
  padding: 20px;
  background: #f5f5f5;
  min-height: calc(100vh - 120px);
}

.form-container {
  background: #fff;
  border-radius: 4px;
  padding: 30px;
  max-width: 800px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 20px;
  font-weight: 500;
  color: #303133;
  margin: 0 0 30px 0;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.category-form {
  margin-top: 20px;
}

::v-deep .el-form-item {
  margin-bottom: 28px;
}

::v-deep .el-form-item__label {
  font-weight: 500;
  color: #606266;
  line-height: 40px;
}

::v-deep .el-form-item__content {
  line-height: 40px;
}

::v-deep .el-input__inner {
  height: 40px;
  line-height: 40px;
}

::v-deep .el-input-number {
  line-height: 40px;
}

::v-deep .el-input-number .el-input__inner {
  text-align: left;
  padding-left: 15px;
  padding-right: 50px;
}

.form-tip {
  margin-left: 10px;
  font-size: 13px;
  color: #909399;
}

::v-deep .el-switch {
  line-height: 40px;
}

::v-deep .el-button {
  padding: 12px 30px;
  font-size: 14px;
}

::v-deep .el-button + .el-button {
  margin-left: 15px;
}

::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>
